<template>
  <div>
    <b-table
      :data="users"
      :columns="columns"
      :loading="$apollo.loading"
      v-if="users">

      <template slot-scope="props">
        <b-table-column field="name">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column field="email">
          {{ props.row.email }}
        </b-table-column>
        <b-table-column field="isAdmin">
          {{ props.row.isAdmin ? 'ADMIN' : '' }}
        </b-table-column>
        <b-table-column field="manage">
          <a @click="openManageModal(props.row)">Manage User</a>
        </b-table-column>
      </template>
    </b-table>

    <!--Manage User Modal-->
    <user-manage-modal :user="modalUser" ref="manageModal" @delete="refetchUsers()" v-if="modalUser"></user-manage-modal>
  </div>
</template>

<script>
import { usersQuery } from '../../graphql/users'
import UserManageModal from './UserManageModal.vue'

export default {
  components: {
    UserManageModal
  },
  data () {
    return {
      columns: [
        {
          field: 'name',
          label: 'Name'
        },
        {
          field: 'email',
          label: 'Email'
        },
        {
          field: 'isAdmin',
          label: 'Admin'
        },
        {
          field: 'manage',
          label: 'Manage'
        }
      ],
      modalUser: null
    }
  },
  apollo: {
    users: {
      query: usersQuery,
      variables: {
        orderBy: 'email_ASC',
        after: null
      },
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    // open the modal to manage an user
    openManageModal (user) {
      this.modalUser = user
      // wait for modal to create now that the user is set
      this.$nextTick(function () {
        this.$refs.manageModal.$refs.modal.open()
      })
    },
    // refetch the users list after the contents may have changed
    refetchUsers () {
      this.$apollo.queries.users.refetch()
    }
  }
}
</script>
